import React from 'react';
import '../naomi/NaomiSectionConfig';
import '../naomi/NaomiPreview';
import { NaomiStudio } from '../naomi/NaomiStudio';

const Naomi: React.FC = () => (
  <div style={{ height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
    <NaomiStudio />
  </div>
);

export default Naomi;
